import { Link } from 'react-router-dom';

const Header = () => {
  return (
    <header data-aos="fade-up" className="relative w-full h-auto md:h-screen bg-cover bg-center" style={{ backgroundImage: `url(https://res.cloudinary.com/dkmxvgmxd/image/upload/v1755621836/header_djwstv.jpg?v=1)` }}>
      {/* Container for text and buttons */}
      <div className="flex flex-col justify-center items-center h-auto md:h-full text-center text-white z-20">
        {/* Image Text */}
        <div className="mb-20 mt-20 md:mt-0">
          <img
            src="https://res.cloudinary.com/dkmxvgmxd/image/upload/v1755621365/springdales_bhfp0o.png?v=1"
            alt="Springdales"
            className="max-w-full h-auto" loading="lazy"
          />
        </div>

        {/* Bouncy Text Banner */}
        <div className="bg-[#B70404] text-white text-rl px-8 py-4 rounded-full shadow-xl border-4 border-white font-extrabold text-lg sm:text-2xl tracking-wide animate-bounce mb-8">
          🎓 2025-26 admissions are now open!
        </div>

        {/* CTA Buttons */}
        <div className="flex gap-6 justify-center mb-20 md:mb-0">
          <Link
            to="/about"
            className="bg-[#0077CC] text-white px-6 py-3 rounded-full font-semibold text-base sm:text-lg hover:bg-[#0196ad] transition flex items-center"
          >
            Learn More
          </Link>
          <Link
            to="/contact"
            className="bg-white text-[#d62828] border-2 border-[#d62828] px-6 py-3 rounded-full font-semibold text-base sm:text-lg hover:bg-[#ffe5e5] transition"
          >
            📞 Contact Us
          </Link>
        </div>
      </div>
    </header>
  );
};

export default Header;
